import { Component, Vue } from 'vue-property-decorator';
import template from './my-appointments.vue';
import { Appointment, ModalComponents } from '@/definitions';
import apiService from '@/services/api.service';
import { Action } from '@/store';

@Component({
  mixins: [template],
})
export default class MyAppointments extends Vue {

  loading: boolean = false;

  get appointments(): Appointment[] {
    return this.$Store.state.myAppointments;
  }

  mounted() {
    this.loading = true;
    this.getAppointments();
  }

  async getAppointments() {
    try {
      await apiService.getMyAppointments();
      this.loading = false;
    } catch (e) {
      const error = e as Error;
      console.error(error);
    }
  }

  visibleHour(hour: number): string {
    const h = (hour < 10) ? `0${hour}` : hour;
    return `${h}:00`;
  }

  removeAppointment(appointment: Appointment) {
    const modalData = {
      component: ModalComponents.REMOVE_APPOINTMENT,
      props: { ...appointment }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }
}